module.exports = __webpack_public_path__ + "img/yangrui.de5e02f0.png";